import { createContext } from 'react'

export class ErrorStore {
  error = []

  setError = (accessCode, errorMessage, errorCode) => {
    this.error.code = accessCode
    this.error.errorMessage = errorMessage
    this.error.errorCode = errorCode
  }
}

export default createContext(new ErrorStore())
